module.exports = __webpack_public_path__ + "img/Woveon4.a8c6a97a.jpg";